<template>
  <span>
    <span v-for="(item, index) in items" :key="item.id">
      <ItemImage v-if="!noImage" inlineThumb :type="type" :id="item.id" />
      <router-link :to="{ path: `/encyclopedia/${type}/${item.category_id}/${item.id}` }">{{ item.name }}</router-link>
      <span v-if="hasQuantity && item.pivot && item.pivot.quantity"> x {{ item.pivot.quantity }}</span>
      <span v-if="hasAnd(index)"> and</span>
      <span v-if="hasComma(index)">,</span>
    </span>
  </span>
</template>

<script>
import ItemImage from '@/components/Encyclopedia/ItemImage.vue';

export default {
  name: 'small-items-list',
  components: { ItemImage },
  props: {
    type: String,
    items: Array,
    noImage: Boolean,
    hasQuantity: Boolean,
  },
  methods: {
    hasComma(index) {
      return !this.hasAnd(index) && index !== this.items.length - 1;
    },
    hasAnd(index) {
      return this.items.length > 1 && index === this.items.length - 2;
    },
  },
};
</script>
